export default {
  tables: {}
}
